export default {
  tables: {}
}
